import { cloneDeep } from "lodash";
import { ChannelModel } from "../../channel/models/ChannelModel";

export enum ActionTypeEnum {
    UseCurrentForm,
    UseChannelSettings,
}

interface ActionType {
    enum: ActionTypeEnum;
    description: string;
}

export class ProductBatchPricePercentageManagementByChannelModel {
    idChannel: number|string|null = null;
    channelWrapper: ChannelModel|null = new ChannelModel();
    pricePercentage: number|null = null;
    priceDecimalsPreference: number|string|null = null;
    priceDecimalsPreferenceString: string|null = null;
    actionTypeList: ActionType[] = [];
    actionType: ActionType|null = null;

    constructor(s?: Partial<ProductBatchPricePercentageManagementByChannelModel>) {
        Object.assign(this, s)

        this._parseActionType();
        this._parsePriceDecimalsPreferenceString();
        this._parseChannel();
    }

    isValid():boolean {
        return !!this.idChannel &&
            !!this.isPricePercentageValid();
    }

    isPricePercentageValid():boolean {
        return !!this.pricePercentage &&
            this.pricePercentage > 0 &&
            this.pricePercentage <= 9999;
    }

    isActionTypeUseCurrentForm():boolean {
        return this.actionType?.enum === ActionTypeEnum.UseCurrentForm
    }

    isActionTypeUseChannelSettings():boolean {
        return this.actionType?.enum === ActionTypeEnum.UseChannelSettings
    }

    normalize(): ProductBatchPricePercentageManagementByChannelModel {
        return new ProductBatchPricePercentageManagementByChannelModel({
            idChannel: this.idChannel,
            actionType: this.actionType,
            actionTypeList: undefined,
            channelWrapper: this.channelWrapper,
            pricePercentage: this.pricePercentage,
            priceDecimalsPreferenceString: this.priceDecimalsPreferenceString,
            priceDecimalsPreference: this.priceDecimalsPreferenceString ? parseInt(this.priceDecimalsPreferenceString, 10) : null,
        })
    }

    normalizeForRestauration(): ProductBatchPricePercentageManagementByChannelModel {
        return new ProductBatchPricePercentageManagementByChannelModel({
            idChannel: this.idChannel,
            actionType: this.actionType,
            actionTypeList: undefined,
            channelWrapper: this.channelWrapper,
            pricePercentage: null,
            priceDecimalsPreferenceString: null,
            priceDecimalsPreference: null,
        })
    }

    private _parsePriceDecimalsPreferenceString():void {
        if (typeof this.priceDecimalsPreference === "number") {
            this.priceDecimalsPreferenceString = this.priceDecimalsPreference < 10 ? `0${this.priceDecimalsPreference}` : `${this.priceDecimalsPreference}`
            return
        }
    }

    private _parseChannel():void {
        this.channelWrapper = new ChannelModel(this.channelWrapper as ChannelModel);
    }

    private _parseActionType():void {
        this.actionTypeList = [
            {enum: ActionTypeEnum.UseCurrentForm, description: 'Utilizar informações configuradas NESTE FORMULÁRIO.'},
            {enum: ActionTypeEnum.UseChannelSettings, description: 'Restaurar informações baseado nas configurações DO CANAL.'},
        ];
        this.actionType = this.actionTypeList.find((at) => at.enum === this.actionType?.enum) || cloneDeep(this.actionTypeList[0])
    }
}

